const SKIP_ONBOARDING_VIDEO_EMAILS: string[] = [
  'mobile_tester@medely.com',
  // iOS - 2FA Maestro test account
  'account_735465@medely.com',
  // Android - 2FA Maestro test account
  'account_735469@medely.com',
];

export const shouldSkipOnboardingModal = (email: string | null | undefined): boolean => {
  if (!email) {
    return false;
  }

  const normalizedEmail = email.toLowerCase().trim();

  return SKIP_ONBOARDING_VIDEO_EMAILS.includes(normalizedEmail);
};

export const getSkipEmails = (): string[] => {
  return SKIP_ONBOARDING_VIDEO_EMAILS;
};
